import { useQuery } from '@tanstack/react-query';
import { useParams } from '@tanstack/react-router';
import {
  Area,
  AreaChart,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';

import { api } from '../../../lib/api.js';
import { UsageResponse } from '@raven/shared-types';

export function InsightsPage() {
  const { id } = useParams({ strict: false }) as { id: string };
  const { data, isPending } = useQuery({
    queryKey: ['usage', id],
    queryFn: () => api.get(`/api/workspaces/${encodeURIComponent(id)}/usage`, UsageResponse),
  });

  return (
    <div className="space-y-4">
      <div className="card">
        <h3 className="text-base font-semibold">Hits vs Renders</h3>
        <div className="mt-4 h-64">
          {isPending ? (
            <div className="text-sm text-slate-400">Loading…</div>
          ) : (
            <ResponsiveContainer width="100%" height="100%">
              <AreaChart data={data?.buckets ?? []}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="date" />
                <YAxis />
                <Tooltip />
                <Legend />
                <Area
                  type="monotone"
                  dataKey="totalHits"
                  stroke="#2563eb"
                  fill="#bfdbfe"
                  stackId="1"
                />
                <Area
                  type="monotone"
                  dataKey="totalRendered"
                  stroke="#16a34a"
                  fill="#bbf7d0"
                  stackId="2"
                />
              </AreaChart>
            </ResponsiveContainer>
          )}
        </div>
      </div>
    </div>
  );
}
